import { render, staticRenderFns } from "./yunqi.vue?vue&type=template&id=7267f8e2&"
import script from "./yunqi.vue?vue&type=script&lang=ts&"
export * from "./yunqi.vue?vue&type=script&lang=ts&"
import style0 from "./yunqi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports